import styled from 'styled-components';

const FormStyles = `
width: 260px;
height: 50px;
margin-bottom: 15px;
padding: 16px;
font-family: 'Gilroy';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 19px;
background: rgba(24, 24, 40, 1);
color: #fff;
outline:none;
@media (min-width: 768px) {
  width: 290px;
}
`;

export const TitleWrapper = styled.div`
  @media (min-width: 1280px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-right: 100px;
  }
`;

export const TitleTextWrapper = styled.div``;

export const ContactUs = styled.h1`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 38px;
  color: #ffffff;
  @media (max-width: 1279px) {
    text-align: center;
  }
`;

export const Question = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #aaabbc;
  padding: 20px 0;
  @media (max-width: 1279px) {
    text-align: center;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 1279px) {
    margin: 0 0 34px;
  }
`;

export const FormSection = styled.section`
  display: block;
  padding: 150px 0 50px;
  width: 100%;
`;

export const FormWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  border: 1px solid #444454;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1),
    0px 12px 12px -4px rgba(19, 19, 23, 0.9);
  border-radius: 8px;
  padding: 10px;
  width: fit-content;
  margin: 0 auto;
  @media (max-width: 1279px) {
    flex-direction: column;
    align-items: center;
  }
  @media (min-width: 768px) {
    padding: 42px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  position: absolute;
  background: rgba(24, 24, 40, 1);
  margin-top: -9px;
  padding: 0 6px;
  z-index: 1;
  color: red;
  margin-left: 20px;
`;

export const Input = styled.input`
  ${FormStyles}
  border: ${(props: any) =>
    props.error
      ? `1px solid red`
      : `1px solid rgba(129, 140, 155, 0.4)`};

  & :hover {
    border: 1px solid #7165e3;
  }

  & :focus {
    outline: none;
    border: 1px solid #7165e3;
  }

  ::placeholder {
    color: #818c9b;
  }

  :focus::placeholder {
    color: transparent;
  }

  @media (min-width: 768px) {
    width: 400px;
  }
`;

export const TextArea = styled.textarea`
  ${FormStyles}
  border: ${(props: any) =>
    props.error
      ? `1px solid red`
      : `1px solid rgba(129, 140, 155, 0.4)`};
  height: 160px;
  resize: none;
  margin-bottom: 30px;

  & :hover {
    border: 1px solid #7165e3;
  }

  & :focus {
    outline: none;
    border: 1px solid #7165e3;
  }

  ::placeholder {
    color: #818c9b;
  }

  :focus::placeholder {
    color: transparent;
  }

  @media (min-width: 768px) {
    width: 400px;
    margin-bottom: 40px;
  }
`;

export const Button = styled.button`
  /* width: 136px;
  height: 50px; */
  border-radius: 2px;
  width: 100%;
  padding: 20px 0;
  border: none;
  background: #ffd324;
  font-family: 'Gilroy';
  font-weight: 600;
  cursor: pointer;
  color: #fff;
  outline: none;
  border: 1px solid #2b70fa;
  background: ${({ hovered }: any) =>
    hovered ? 'transparent' : '#2b70fa'};
`;

export const FormImg = styled.img`
  display: block;
  width: 260px;
  height: 190px;
  @media (min-width: 376px) {
    width: 294px;
  }
`;

export const FormImgWrapper = styled.div`
  @media (min-width: 1280px) {
    padding: 0px 0 40px;
  }
`;
